import { useFacturationService, useSociete } from '@europrocurement/l2d-domain';
import {
    ArticlesEtRemisesDesDossiersDeFormalitApiApiReductionArticlesDossierGetCollectionRequest,
    ArticlesEtRemisesDesDossiersDeFormalitJsonldDonneesFacturationRead,
    DossierFacturableDTOJsonldDonneesFacturationRead,
    FacturationFormalitApiApiDossierFormaliteGetCollectionRequest,
} from '@europrocurement/l2d-domain/openApi/ApiFacturation';

export type DossiersArticlesReductions =
    ArticlesEtRemisesDesDossiersDeFormalitJsonldDonneesFacturationRead & Record<string, unknown>;

const useDossierPrefacturation = () => {
    const { facturationFormaliteApi, articlesEtRemisesDesDossiersDeFormalitApi } =
        useFacturationService();
    const xIdSociete = useSociete();
    let searchStatutTimeout: number | undefined;
    let testDossierTimeout: number | undefined;

    const getDossiersFacturables = (dossiers: Array<number>): Promise<Array<number>> =>
        new Promise((resolve, reject) => {
            clearTimeout(testDossierTimeout);
            const requestParameters: FacturationFormalitApiApiDossierFormaliteGetCollectionRequest =
                {
                    ids: dossiers,
                    xIdSociete,
                };
            testDossierTimeout = setTimeout(() => {
                facturationFormaliteApi
                    .apiDossierFormaliteGetCollection(requestParameters)
                    .then((res) => {
                        const dossiersTestes: DossierFacturableDTOJsonldDonneesFacturationRead[] =
                            res.data?.['hydra:member']?.[0]?.dossiers ?? [];
                        const ids = dossiersTestes
                            .filter((d) => d?.dossierFacturable)
                            .map((d) => d.id)
                            .filter((id): id is number => typeof id === 'number');
                        resolve(ids);
                    })
                    .catch((error) => reject(error));
            }, 300);
        });

    const searchDossierArticlesEtReductions = (
        ids: Array<number>,
        idsSelected: Array<number>,
    ): Promise<DossiersArticlesReductions> =>
        new Promise((resolve, reject) => {
            if (ids.length === 0) {
                console.log('No ids provided');
                reject(new Error('No ids provided'));
                return;
            }

            clearTimeout(searchStatutTimeout);
            const requestParameters: ArticlesEtRemisesDesDossiersDeFormalitApiApiReductionArticlesDossierGetCollectionRequest =
                { ids, idsSelected, xIdSociete };

            searchStatutTimeout = setTimeout(() => {
                articlesEtRemisesDesDossiersDeFormalitApi
                    .apiReductionArticlesDossierGetCollection(requestParameters)
                    .then((res) => {
                        resolve(res.data['hydra:member'][0] as DossiersArticlesReductions);
                    })
                    .catch((err) => reject(err));
            }, 300);
        });

    return { searchDossierArticlesEtReductions, getDossiersFacturables };
};

export default useDossierPrefacturation;
